import { useTranslation } from "react-i18next";
import { Sjabloon } from "@/features/wedstrijdboekjes/Sjabloon";
import { BeheerderShell } from "@/components/BeheerderShell";

export function SjabloonPage() {
  const { t } = useTranslation(["paginas", "navigatie"]);

  return (
    <BeheerderShell
      titel={t("navigatie:paginas.wedstrijdboekjesSjabloon.label")}
      uitleg={t("wedstrijdboekjesSjabloon.uitleg")}
    >
      <Sjabloon />
    </BeheerderShell>
  );
}
